import gsap from 'gsap';
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
gsap.registerPlugin(ScrollToPlugin);

class Map {
  constructor(element) {
    this.element = element
    this.nextButton = this.element.querySelector('[data-navigation="next"]')
    this.previousButton = this.element.querySelector('[data-navigation="previous"]')
    this.mapWrapper = this.element.querySelector('.modules-map__map-wrapper')
    this.mapImage = this.mapWrapper.querySelector('img')

    this.handleNavigationButtonClick = this.handleNavigationButtonClick.bind(this)
    this.handleWrapperScroll = this.handleWrapperScroll.bind(this)
  }

  handleNavigationButtonClick(event) {
    event.preventDefault()

    const target = event.target
    let scrollPosition = {};
    if (target.dataset.navigation === 'next') {
      scrollPosition = {y: 0, x: this.xScroll }
    } else if (target.dataset.navigation === 'previous') {
      scrollPosition = {y: 0, x: 0}
    }

    gsap.to(this.mapWrapper, {
      duration: 1,
      scrollTo: scrollPosition,
    });
  }

  updateNavigationDisplay() {
    if (this.mapWrapper.scrollLeft == 0) {
      gsap.to(this.previousButton, { opacity: 0, })
    } else {
      gsap.to(this.previousButton, { opacity: 1, })
    }

    if (this.mapWrapper.scrollLeft >= this.xScroll) {
      gsap.to(this.nextButton, { opacity: 0, })
    } else {
      gsap.to(this.nextButton, { opacity: 1, })
    }
  }

  handleWrapperScroll() {
    this.updateNavigationDisplay()
  }

  setXScroll() {
    const mapRect = this.mapImage.getBoundingClientRect()
    const wrapperRect = this.mapWrapper.getBoundingClientRect()

    this.xScroll = mapRect.width - wrapperRect.width
  }

  init() {
    this.nextButton.addEventListener('click', this.handleNavigationButtonClick)
    this.previousButton.addEventListener('click', this.handleNavigationButtonClick)

    this.mapWrapper.addEventListener('scroll', this.handleWrapperScroll)

    window.addEventListener('resize', () => {
      this.setXScroll()
    })

    this.updateNavigationDisplay()
    this.setXScroll()
  }
}

export default Map;
